import {onDOMLoaded} from "./misc";

export default class DOMComponentRegistry {
    constructor() {
        this.instances = [];
        this.registerEvents();
    }

    registerEvents() {
        onDOMLoaded(() => {
            this.initializeAll();
        })
    }

    initializeOne() {
        throw "This is an abstract method, overwrite it in your own class";
    }

    initializeAll() {
        this.instances.forEach(instance => {
            this.initializeOne.call(this, ...instance);
        });
    }

    createNew() {
        this.instances.push(Array.from(arguments));
    }
}